import { render, staticRenderFns } from "./LiveCard.vue?vue&type=template&id=41dcbbb9&scoped=true&"
import script from "./LiveCard.vue?vue&type=script&lang=js&"
export * from "./LiveCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dcbbb9",
  null
  
)

export default component.exports